module.exports = __webpack_public_path__ + "static/media/iconlibrary.cbe23be8.svg";